module.exports = __webpack_public_path__ + "static/img/MarnusLabuschagne.2426f5b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/MarnusLabuschagne.jpg
// module id = dBuh
// module chunks = 0